import {t} from '@lingui/core/macro';

import {IMassOperationAction} from 'shared/ui/MassOperations/MassOperations';
import {getCommonMassOperationActions} from 'shared/ui/MassOperations/massOperationActions';
import {
    buildCommonBatchRequest,
    getBatchResultTitle,
    IBatchOperationRequest,
    IBuildBatchRequestParams,
} from 'entities/monitor';

export interface ServerBatchOperationsFormValues {
    tags: string[],
}

export const getServerBatchOperationsDefaults = (): ServerBatchOperationsFormValues => ({tags: []});

export const buildServerBatchOperationRequest = ({
    actionValue,
    formData,
    selectedIds,
}: IBuildBatchRequestParams<ServerBatchOperationsFormValues>): IBatchOperationRequest =>
    buildCommonBatchRequest(actionValue, selectedIds, formData.tags);

export const getServerMassOperationActions = (): IMassOperationAction[] =>
    getCommonMassOperationActions()
        .filter(({value}) => value !== 'edit')
        .map((action) => {
            switch (action.value) {
                case 'start':
                    return {...action, label: t`возобновление`, title: t`Возобновить`};
                case 'stop':
                    return {...action, label: t`пауза`};
                default:
                    return action;
            }
        });

export function getServerBatchModalHeader(actionValue?: string): string {
    switch (actionValue) {
        case 'start':
            return t`Массовое возобновление серверов`;
        case 'stop':
            return t`Массовая пауза серверов`;
        case 'delete':
            return t`Массовое удаление серверов`;
        case 'tags':
            return t`Массовое добавление тегов`;
        default:
            return t`Массовые операции`;
    }
}

export function getServerBatchResultTitle(actionValue?: string): string {
    switch (actionValue) {
        case 'start':
            return t`Серверы возобновлены`;
        case 'stop':
            return t`Серверы поставлены на паузу`;
        default:
            return getBatchResultTitle(actionValue);
    }
}
